import {
    buildEffectWithElementHook,
    IHookListener,
} from "../../_shared/elementForFeatureHook";
import { buildListenerOnDiff } from "../../_store/customScrollStoreDomain";
import { IPerfectScrollState } from "../../scroll/perfectScrollModel";
import { setCustomScrollStatusAction } from "../../_store/customScrollStatus";
import { isAllPropsDefined } from "../../_utils/predicates";
import { isObjectPropsEquals } from "../../_utils/equality";

export const useShowScrollBarsOnDemandFeature = buildEffectWithElementHook(
    (element, store, extensions) =>
        buildListenerOnDiff(
            store,
            selectArgs,
            buildFeature(element, store, extensions)
        )
);

const selectArgs = (s: IPerfectScrollState) => ({
    innerChangeTick: s.status?.innerChangeTick,
    suppressScrollX: s.options?.suppressScrollX ?? false,
    suppressScrollY: s.options?.suppressScrollY ?? false,
    scrollXMarginOffset: s.options?.scrollXMarginOffset ?? 0,
    scrollYMarginOffset: s.options?.scrollYMarginOffset ?? 0,
    containerWidth: s.horizontalDimension?.containerMeasure,
    containerHeight: s.verticalDimension?.containerMeasure,
    contentWidth: s.horizontalDimension?.contentMeasure,
    contentHeight: s.verticalDimension?.contentMeasure,
    current: {
        scrollbarYActive: s.status?.scrollbarYActive ?? false,
        scrollbarXActive: s.status?.scrollbarXActive ?? false,
    },
});

const buildFeature: IHookListener<typeof selectArgs> = (
    element,
    { dispatch }
) => i => {
    if (!isAllPropsDefined(i)) return;

    const newStatus = {
        scrollbarXActive:
            !i.suppressScrollX &&
            i.containerWidth + i.scrollXMarginOffset < i.contentWidth,

        scrollbarYActive:
            !i.suppressScrollY &&
            i.containerHeight + i.scrollYMarginOffset < i.contentHeight,
    };

    !isObjectPropsEquals(newStatus, i.current) &&
        dispatch(setCustomScrollStatusAction(newStatus));
};
